import type { Stage } from "../audio";

interface Props {
  currentStage: Stage;
  guesses: string[];
}

const STAGES: Stage[] = [1, 2, 3, 4, 5, 6];

export function StageIndicator({ currentStage, guesses }: Props) {
  return (
    <div className="flex gap-1.5 justify-center">
      {STAGES.map((s) => {
        const guessResult = guesses[s - 1];
        const isWrong = guessResult === "wrong";
        const isSkip = guessResult === "skip";
        const isCorrect = guessResult === "correct";
        const isActive = s === currentStage && guesses.length < 6;
        const isPending = !guessResult && s > currentStage;

        let background: string;
        if (isCorrect) background = "var(--gold-400)";
        else if (isWrong || isSkip) background = "rgba(212,162,74,0.18)";
        else if (isActive) background = "var(--gold-500)";
        else if (isPending) background = "rgba(212,162,74,0.2)";
        else background = "rgba(212,162,74,0.35)";

        return (
          <span
            key={s}
            className="rounded-full transition-all"
            style={{
              width: isActive ? 10 : 8,
              height: isActive ? 10 : 8,
              background,
              boxShadow: isActive ? "0 0 6px rgba(212,162,74,0.55)" : "none",
              opacity: isPending ? 0.7 : 1,
            }}
            aria-label={
              isCorrect ? `stage ${s} correct`
              : isWrong ? `stage ${s} wrong`
              : isSkip ? `stage ${s} skipped`
              : `stage ${s}`
            }
          />
        );
      })}
    </div>
  );
}
